import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '😰',
  title: 'Ves señales de salud mental y no sabés si actuar',
  description: 'TDAH, depresión, TEA, ansiedad: ¿es patología o es la edad? Sin sistema claro para evaluarlo.'
}, {
  emoji: '📋',
  title: 'Documentás sin saber si te protege legalmente',
  description: 'Sin plantillas adaptadas a salud mental pediátrica que te blinden si algo sale mal.'
}, {
  emoji: '🧠',
  title: 'Sospechás abuso pero no sabés qué hacer',
  description: 'Sin protocolo claro de denuncia obligatoria que te proteja sin destruir el vínculo con la familia.'
}, {
  emoji: '📚',
  title: 'Nada práctico para tu realidad de consultorio',
  description: 'Los libros no contemplan la complejidad legal de detectar y actuar ante problemas de salud mental en menores.'
}, {
  emoji: '💬',
  title: 'Los padres te preguntan y no tenés la respuesta',
  description: '"¿Tiene TDAH? ¿Es autismo? ¿Necesita medicación?" Sin herramientas para responder con autoridad y documentar lo que decidís.'
}, {
  emoji: '⚖️',
  title: 'No dominás el marco legal de salud mental en menores',
  description: 'Consentimiento, denuncia obligatoria, derivación, coordinación con juzgado: zona gris sin sistema.'
}, {
  emoji: '🚨',
  title: 'Tu documentación no refleja lo que evaluaste',
  description: 'Si algo sale mal en un caso con señales de salud mental, tu historia clínica no demuestra que actuaste correctamente.'
}, {
  emoji: '🩺',
  title: 'La derivación llega tarde o no llega',
  description: 'Sin protocolo claro de cuándo derivar, a quién y cómo documentar el proceso para protegerte.'
}];
export function PainPoints() {
  return <section className="bg-slate-100 py-12 sm:py-28" data-id="element-202">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-203">
        <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-16" data-id="element-204">
          <h2 className="text-[10px] sm:text-sm font-semibold tracking-wide text-slate-500 uppercase mb-1.5 sm:mb-3" data-id="element-205">
            REALIDAD DE LA CONSULTA PEDIÁTRICA
          </h2>
          <p className="text-2xl font-bold tracking-tight text-slate-900 sm:text-4xl mb-2 sm:mb-4" data-id="element-206">
            ¿TE PASA ESTO?
          </p>
          <p className="text-sm sm:text-lg text-slate-600" data-id="element-207">
            Si atendés niños y adolescentes en Argentina, esto te suena
            familiar:
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6 mb-8 sm:mb-16" data-id="element-208">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} whileHover={{
          y: -5,
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm ring-1 ring-slate-200/60 hover:shadow-lg hover:ring-blue-200 transition-all cursor-pointer flex sm:block items-start gap-3 sm:gap-0" data-id="element-209">
              <div className="text-2xl sm:text-3xl mb-0 sm:mb-4 flex-shrink-0 mt-0.5 sm:mt-0" data-id="element-210">
                {point.emoji}
              </div>
              <div data-id="element-211">
                <h3 className="text-sm sm:text-lg font-semibold text-slate-900 mb-1 sm:mb-2 leading-snug" data-id="element-212">
                  {point.title}
                </h3>
                <p className="text-slate-600 text-[11px] sm:text-sm leading-relaxed" data-id="element-213">
                  {point.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} whileHover={{
        scale: 1.02
      }} className="text-center max-w-2xl mx-auto bg-blue-50 rounded-xl sm:rounded-2xl p-5 sm:p-8 ring-1 ring-blue-200 shadow-sm cursor-pointer" data-id="element-214">
          <p className="text-base sm:text-xl font-medium text-blue-900" data-id="element-215">
            ¿Cuántas consultas más sin un sistema que respalde cada decisión
            clínica y te blinde legalmente?
          </p>
        </motion.div>
      </div>
    </section>;
}